import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  provideKeycloak,
} from 'keycloak-angular';
import { KeycloakConfig } from 'keycloak-js';

export const provideDefaultKeycloak = () =>
  provideKeycloak({
    providers: [
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [
          createInterceptorCondition<IncludeBearerTokenCondition>({
            urlPattern:
              /^(http|https):\/\/(localhost|(api|api\.v2)\.(claims-terminal\.)?((dev|test|prod)\.)?(personenschaden\.vyda\.de|personenschaden\.eucon\.com|attest-leicht-gemacht\.de))([/:?].*)?$/i,
          }),
        ],
      },
    ],
    initOptions: {
      onLoad: 'login-required',
      checkLoginIframe: false,
    },
    config: './assets/config/keycloak.json' as unknown as KeycloakConfig,
  });
